import { connect } from 'react-redux';

import { GlobalState } from 'ha/types/store';
import {
  getMarkers,
  getMapCenter,
  getUniversities,
  isMobileMapOpen,
} from 'ha/pages/Search/selectors';

import SearchMap from 'ha/pages/Search/components/SearchMap';
import { onMapChanged, toggleMapAutoSearch } from '../actions';

export default connect(
  (state: GlobalState) => ({
    initialized: state.search.loadState.initialized,
    mapZoom: state.search.map.zoomLevel,
    highlightedRoomId: state.search.map.highlightedRoomId,
    scrollwheel: state.search.map.scrollwheel,
    markers: getMarkers(state),
    universities: getUniversities(state),
    mapCenter: getMapCenter(state),
    isMobileMapOpen: isMobileMapOpen(state),
  }),
  {
    onMapChanged,
    toggleMapAutoSearch,
  },
)(SearchMap);
